export default __webpack_public_path__ + "static/media/undo.2197aa9e.svg";